import React, { useState, useEffect, useContext, useRef } from "react";

import { DataGrid } from "@material-ui/data-grid";
import { Container, Grid, IconButton, Tooltip } from "@material-ui/core";
import { EditOutlined, CheckOutlined, AddOutlined } from "@material-ui/icons";

import { GridStyled, IconButtonStyled } from "../../styles/GlobalStyle";
import { TitleTable } from "../../components/basic/TitleTable";
import filterTable from "../../utils/filterTable";
import { ServicesCreateEdit } from "./ServiceCreateEdit";
import { getServices } from "../../repositories/v1/service";
import { UserContext } from "../../context/UserContext";

function ServicePreview() {
  const { user } = useContext(UserContext);
  const [page, setPage] = useState(0);
  const [allRows, setAllRows] = useState([]);
  const [rowsFilter, setRowsFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowEdit, setRowEdit] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const searchRef = useRef(null);

  const columns = [
    {
      field: "Id",
      headerName: "Id",
      width: 100,
    },
    {
      field: "Descricao",
      headerName: "Descrição",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "FlagAtivo",
      headerName: "Ativo",
      minWidth: 100,
      flex: 0.2,
      renderCell: ({ row }) => (row?.FlagAtivo ? <CheckOutlined /> : "-"),
      align: "center",
    },
    {
      field: "FlagUtilizador",
      headerName: "Utilizador",
      minWidth: 100,
      flex: 0.2,
      renderCell: ({ row }) => (row?.FlagUtilizador ? <CheckOutlined /> : "-"),
      align: "center",
    },
  ];

  if (user.accessRoutes.includes("/editService")) {
    columns.unshift({
      field: "Acoes",
      headerName: "Acões",
      width: 80,
      renderCell: ({ row }) => (
        <Tooltip title="Editar Serviço">
          <IconButton
            onClick={() => {
              setRowEdit(row);
              setOpenModal(true);
            }}
          >
            <EditOutlined />
          </IconButton>
        </Tooltip>
      ),
      align: "center",
    });
  }

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const { data: response } = await getServices();

        setAllRows(response.data);
        setRowsFilter(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleChangeFilter = (e) => {
    e.preventDefault();

    if (!searchRef?.current?.value) return setRowsFilter(allRows);

    const newArr = filterTable({
      data: allRows,
      text: searchRef?.current?.value,
      columns: ["Id", "Descricao"],
    });

    setRowsFilter(newArr);
    setPage(0);
  };

  const handleSave = (body) => {
    const copyAllRows = [...allRows];
    const copyRowsFilter = [...rowsFilter];

    if (rowEdit.Id) {
      const indexAllRows = copyAllRows.findIndex((i) => i.Id === rowEdit.Id);
      copyAllRows[indexAllRows] = body;

      const indexRowsFilter = copyRowsFilter.findIndex(
        (i) => i.Id === rowEdit.Id
      );
      copyRowsFilter[indexRowsFilter] = body;

      setAllRows(copyAllRows);
      setRowsFilter(copyRowsFilter);
      return;
    }

    setAllRows([...copyAllRows, body]);
    setRowsFilter([...copyRowsFilter, body]);
  };

  const handleClose = () => {
    setOpenModal(false);
    setRowEdit({});
  };

  return (
    <Container maxWidth="lg">
      {openModal && (
        <ServicesCreateEdit
          row={rowEdit}
          handleClose={handleClose}
          handleSave={handleSave}
        />
      )}
      <GridStyled
        container
        padding="20px 0 20px 0"
        justify="space-between"
        spacing={3}
      >
        <Grid item xs={12}>
          <TitleTable
            inputRef={searchRef}
            labelFilter="Filtro (Id, Descrição)"
            title="Serviços"
            handleFilter={handleChangeFilter}
            loading={loading}
            children={
              user.accessRoutes.includes("/createService") ? (
                <Grid item flex={1}>
                  <Tooltip title="Adicionar Serviço">
                    <IconButtonStyled
                      onClick={() => {
                        setOpenModal(true);
                        setRowEdit({});
                      }}
                    >
                      <AddOutlined />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              ) : null
            }
          />
        </Grid>

        <Grid item xs={12}>
          <DataGrid
            autoHeight
            disableColumnMenu
            loading={loading}
            rows={rowsFilter}
            columns={columns}
            pageSize={10}
            getRowId={(row) => row.Id}
            page={page}
            onPageChange={(e) => setPage(e?.page || 0)}
          />
        </Grid>
      </GridStyled>
    </Container>
  );
}

export { ServicePreview };
